import Dinero from 'dinero.js';
import invoiceNumberGenerate from './invoiceNumberGenerate';

const zero = Dinero({ amount: 0, precision: 2, currency: 'CHF' });
const zeroJson = zero.toJSON();

export default function(date) {
  const number = invoiceNumberGenerate();
  return {
    type: 'invoice',
    patient: {},
    patientId: 'patient',
    issuer: {},
    issuerId: 'issuer',
    noProvider: true,
    provider: {},
    providerId: 'provider',

    number,
    date,
    reason: 'illness',

    //note: 'Nombre de séances restantes : X / Traitement terminé',
    note: '',
    copies: ['patient', 'issuer'],
    lines: [
      {
        id: 1,
        date,
        tarif: '590',
        code: '',
        minutes: 0,
        hourly: zeroJson,
        vatRate: 0.0,
        amount: zeroJson
      }
    ],
    deposit: zeroJson,
    totalEot: zeroJson,
    totalVat: zeroJson,
    totalTi: zeroJson,
    rounding: zeroJson,
    status: 'draft'
  };
}
